import { render, staticRenderFns } from "./ConfigWebsiteCatalogue.vue?vue&type=template&id=e0b981fc"
import script from "./ConfigWebsiteCatalogue.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports